// extracted by mini-css-extract-plugin
export var placeholder = "vZxa9";
export var shrinkable = "x7wgQ";
export var underlay = "uleLZ";